import * as types from './user-form.types';

export const formSelectors: types.IFormSelectors = {
  selectSelectableAccounts: (state) => state.page.users.userForm.selectableAccounts,
  selectSelectableTeams: (state) => state.page.users.userForm.selectableTeams,
  selectFormAvatar: (state) => state.page.users.userForm.formAvatar,
  selectCropCounter: (state) => state.page.users.userForm.cropCounter,
  selectFormFile: (state) => state.page.users.userForm.formFile,
};
